    const tabs = document.querySelectorAll(".faq-section.calculator-section .tab-item");
    const panels = document.querySelectorAll(".faq-section.calculator-section .tab-panel");
    console.log(tabs);
    //Tabbing Logic
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", (event) => {
        const parentContainer = event.currentTarget.closest('.tab-container');
        const scopeTabs = parentContainer.querySelectorAll('.tab-item')
         const currentTab = event.currentTarget;
        const scopePanels = parentContainer.querySelectorAll('.tab-panel')
        const currentPanel = parentContainer.querySelector(`.tab-panel#panel-${currentTab.id}`);
       

        scopeTabs.forEach((t) => {
          t.classList.remove("active");
          t.setAttribute("aria-selected", "false");
        });
        
        scopePanels.forEach((panel) => panel.classList.remove("active"));
        currentPanel.classList.add("active");
        currentTab.classList.add("active");
        currentTab.setAttribute("aria-selected", "true");

      });
    });




        // Product data structure
const products = {
    Shiplap: {
        MDF: [
            { model: "1056-96096C", description: "1/2-inch x 7 5/16-inch x 96-inch", sqFt: 4.7 },
            { model: "1056-96144C", description: "1/2-inch x 7 5/16-inch x 144-inch", sqFt: 6.94 },
            { model: "1056-960192C", description: "1/2-inch x 7 5/16-inch x 192-inch", sqFt: 9.4 },
            { model: "1056A-96096C", description: "1/2-inch x 5 5/16-inch x 96-inch", sqFt: 3.375 },
            { model: "1056A-96144C", description: "1/2-inch x 5 5/16-inch x 144-inch", sqFt: 4.94 },
            { model: "1056A-96192C", description: "1/2-inch x 5 5/16-inch x 192-inch", sqFt: 6.75 }
        ],
        Pine: [
            { model: "1056F-93192", description: "1/2 x 7.5/16 x 16 FT (Primed Finger Joint)", sqFt: 9.4 },
            { model: "02489-P7048CBGY", description: "3/8 x 4.5/16 x 48 inches Earl Grey", sqFt: 10.83 },
            { model: "02489-P7048CBWH", description: "3/8 x 4.5/16 x 48 inches Soft white", sqFt: 10.83 },
            { model: "04524-93192", description: "5/8 x 5.5/16 x 16 FT (Primed Finger Joint)", sqFt: 6.63 },
            { model: "4524A-93192", description: "5/8 x 7.5/16 x 16 FT (Primed Finger Joint)", sqFt: 9.29 },
            { model: "4524B-92192", description: "5/8 x 9.5/16 x 16 FT (Primed Finger Joint)", sqFt: 11.96 },  
        ],
        Cedar: [
            { model: "1056M-5K096CPK1", description: "1/2 x 5.1/4 x 8FT", sqFt: 13 }
        ]
    },
    Wainscot: {
        MDF: [
            { model: "03047-96096C", description: "3/8 x 5.15/16 x 8FT", sqFt: 3.83 },
            { model: "03701-96096C", description: "5/8 x 5.15/16 x 8FT", sqFt: 3.83 },
            { model: "03701-9G192", description: "5/8 x 5.15/16 x 16FT", sqFt: 7.66 }
        ]
    },
   Slatwall: {
        MDF: [
            { model: "04462-96120C", description: "1/2 x 5.3/8 x 10FT", sqFt: 4.17 },
            { model: "04498-96120C", description: "1/2 x 5.5/16 x 10FT", sqFt: 4.17 }
        ]
    },
   Reeded: {
        MDF: [
            { model: "04497-96120C", description: "1/2 x 5.5/16 x 10FT", sqFt: 4.22 }
        ]
    }
};

        // Populate species dropdown based on selected style
        function updateSpeciesDropdown() {
            const style = document.getElementById("style").value;
            const speciesDropdown = document.getElementById("species");
            const speciesContainer = document.getElementById("species-container");
            const productDropdown = document.getElementById("product");
            const productContainer = document.getElementById("product-container");

            // Reset species and product dropdowns
            speciesDropdown.innerHTML = `<option value="">-- Select Species --</option>`;
            productDropdown.innerHTML = `<option value="">-- Select Product --</option>`;
            productContainer.style.display = "none";

            if (style && products[style]) {
                Object.keys(products[style]).forEach(species => {
                    const option = document.createElement("option");
                    option.value = species;
                    option.textContent = species;
                    speciesDropdown.appendChild(option);
                });
                speciesContainer.style.display = "flex"; // Show species container
            } else {
                speciesContainer.style.display = "none";
                resetInputs(false); // Do not reset style dropdown
            }
        }

        // Populate product dropdown based on selected species
        function updateProductDropdown() {
            const style = document.getElementById("style").value;
            const species = document.getElementById("species").value;
            const productDropdown = document.getElementById("product");
            const productContainer = document.getElementById("product-container");

            // Reset product dropdown
            productDropdown.innerHTML = `<option value="">-- Select Product --</option>`;

            if (style && species && products[style][species]) {
                products[style][species].forEach(product => {
                    const option = document.createElement("option");
                    option.value = product.sqFt;
                    option.textContent = `${product.model} - ${product.description} - ${product.sqFt} sq ft per piece`;
                    productDropdown.appendChild(option);
                });
                productContainer.style.display = "flex"; // Show product container
            } else {
                productContainer.style.display = "none";
            }
        }

        // Show the width and height input fields when a product is selected
        function updateCalculation() {
            const product = document.getElementById("product").value;
            const widthContainer = document.getElementById("width-container");
            const heightContainer = document.getElementById("height-container");
            const width = parseFloat(document.getElementById("width").value);
            const height = parseFloat(document.getElementById("height").value);

            document.getElementById("width-error").textContent = "";
            document.getElementById("height-error").textContent = "";

            if (product) {
                widthContainer.style.display = "flex"; // Show width container
                heightContainer.style.display = "flex"; // Show height container
            } else {
                widthContainer.style.display = "none";
                heightContainer.style.display = "none";
                document.getElementById("result").textContent = "";
                return;
            }

            if (product && width > 0 && height > 0) {
                const totalSquareFeet = width * height;
                const panelSqFt = parseFloat(product);
                const panelsRequired = Math.ceil(totalSquareFeet / panelSqFt);

                document.getElementById("result").textContent =
                    `You need ${panelsRequired} piece(s) of the selected wall paneling.`;
            } else {
                document.getElementById("result").textContent = "";
            }
        }

        // Reset inputs
        function resetInputs(resetStyle = true) {
            if (resetStyle) {
                document.getElementById("style").value = "";
            }
            document.getElementById("species-container").style.display = "none";
            document.getElementById("product-container").style.display = "none";
            document.getElementById("width-container").style.display = "none";
            document.getElementById("height-container").style.display = "none";
            document.getElementById("species").innerHTML = `<option value="">-- Select Species --</option>`;
            document.getElementById("product").innerHTML = `<option value="">-- Select Product --</option>`;
        }




// Baseboard Logic


function calculateMolding() {
            const width = parseFloat(document.querySelector('.baseboard-and-casing #width').value) || 0;
            const length = parseFloat(document.querySelector('.baseboard-and-casing #length').value) || 0;
            const doors = parseInt(document.querySelector('.baseboard-and-casing #doors').value) || 0;
            const windows = parseInt(document.querySelector('.baseboard-and-casing #windows').value) || 0;

  
            // Assumptions
            const doorCasing = 18; // 18 LF per door
            const windowCasing = 15; // 15 LF per window

            // Calculations
            const perimeter = 2 * (width + length);
            let baseboard = perimeter - (doors * 2.6);
             if (baseboard < 0) baseboard = 0;
            const totalDoorCasing = doors * doorCasing;
            const totalWindowCasing = windows * windowCasing;
            const totalCasing = totalDoorCasing + totalWindowCasing;
            const grandTotal = baseboard + totalCasing;

            // Update individual results
            document.querySelector('.baseboard-and-casing #result').innerHTML = `
                <p>Baseboard: <span>${baseboard.toFixed(2)} LF</span></p>
                <p>Door Casing: <span>${totalDoorCasing.toFixed(2)} LF</span></p>
                <p>Window Casing: <span>${totalWindowCasing.toFixed(2)} LF</span></p>
            `;

            // Update totals
            document.querySelector('.baseboard-and-casing #totals').innerHTML = `
                <p>Total Casing (Doors + Windows): <span>${totalCasing.toFixed(2)} LF</span></p>
                <p>Total Baseboard: <span>${baseboard.toFixed(2)} LF</span></p>
                <p>Grand Total: <span>${grandTotal.toFixed(2)} LF</span></p>
            `;
        }